import { z } from 'zod';

export const travelSchema = z
  .object({
    needsTravel: z.boolean().nullable().optional(),
    usesGsaRate: z.boolean().nullable().optional(),
    perDiemBaseRate: z.union([z.number(), z.string()]).nullable().optional(),
    travelDayRateMultiplier: z.union([z.number(), z.string()]).nullable().optional(),
  })
  .passthrough()
  .superRefine((data, ctx) => {
    if (!data.needsTravel) return;

    // Per diem required when not using GSA rates
    if (!data.usesGsaRate && (!data.perDiemBaseRate || Number(data.perDiemBaseRate) <= 0)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['perDiemBaseRate'],
        message: 'Default Per Diem Rate must be greater than 0 when GSA rate is not used',
      });
    }

    // Per diem bounds
    if (data.perDiemBaseRate != null && Number(data.perDiemBaseRate) < 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['perDiemBaseRate'],
        message: 'Per diem rate cannot be negative',
      });
    } else if (data.perDiemBaseRate != null && Number(data.perDiemBaseRate) > 1000) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['perDiemBaseRate'],
        message: 'Per diem rate cannot exceed $1,000',
      });
    }

    // Travel day rate multiplier required
    if (!data.travelDayRateMultiplier || Number(data.travelDayRateMultiplier) <= 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['travelDayRateMultiplier'],
        message: 'Travel shift rate multiplier is required when travel is enabled',
      });
    }

    // Travel day rate multiplier upper bound
    if (data.travelDayRateMultiplier && Number(data.travelDayRateMultiplier) > 10) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['travelDayRateMultiplier'],
        message: 'Travel shift rate multiplier cannot exceed 10.0',
      });
    }
  });

export type TravelSchemaData = z.infer<typeof travelSchema>;
